import type { RevenueCatSubscription } from "../types"

/**
 * - `active`: gives access and renews.
 * - `canceled`: gives access until `expires_date`, then ends (no renewal).
 * - `expired`: ran out.
 * - `refunded`: refunded, so no access whatever `expires_date` says.
 */
export type SubscriptionState = "active" | "canceled" | "expired" | "refunded"

type StateFields = Pick<
  RevenueCatSubscription,
  "expires_date" | "refunded_at" | "unsubscribe_detected_at"
>

export function getSubscriptionState(
  subscription: StateFields,
  now: number = Date.now(),
): SubscriptionState {
  if (subscription.refunded_at) return "refunded"

  const expires = new Date(subscription.expires_date).getTime()

  // NOTE: RevenueCat sends a null expires_date for lifetime purchases.
  const isRunning = subscription.expires_date == null || expires > now

  if (!isRunning) return "expired"

  return subscription.unsubscribe_detected_at ? "canceled" : "active"
}

/** Whether the subscription still gives Pro access (active or canceled). */
export function hasAccess(
  subscription: StateFields,
  now: number = Date.now(),
): boolean {
  const state = getSubscriptionState(subscription, now)

  return state === "active" || state === "canceled"
}
